import State from 'store/State';
import { selectOpenSubmissionsState } from '../selectors';
import { useSelector } from 'react-redux';
import { initialOpenSubmissionsConfiguration } from './OpenSubmissionsConfiguration';

export const selectOpenSubmissionsConfiguration = (
    state: State,
    widgetKey: string
) => {
    const openSubmissionsState = selectOpenSubmissionsState(state, widgetKey);
    return openSubmissionsState && openSubmissionsState.config
        ? openSubmissionsState.config
        : initialOpenSubmissionsConfiguration;
};

export const useOpenSubmissionsConfigurationSelector = (widgetKey: string) =>
    useSelector((state: State) =>
        selectOpenSubmissionsConfiguration(state, widgetKey)
    );
